<template>
  <transition name="modal">
    <div class="modal-mask" @click="maskClicked">
      <div class="modal-wrapper">
        <div class="modal-container" ref="modalContainer">
          <div class="modal-header">
            <closeSvg class="close-btn" @click="$emit('close')"></closeSvg>

            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body">[[modal body]]</slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              [[modal footer]]
              <button class="modal-default-button" @click="$emit('close')">OK</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import closeSvg from '@/assets/svg/_ionicons_svg_ios-close.svg?inline';

export default {
  name: "Modal",
  components: { closeSvg },
  data() {
    return {
      escapeKeyHandler: e => {
        if (e.key === "Escape") {
          this.$emit("close");
        }
      }
    };
  },
  methods: {
    maskClicked(event) {
      if (!this.$refs.modalContainer.contains(event.target)) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    window.addEventListener("keydown", this.escapeKeyHandler);
  },
  destroyed() {
    window.removeEventListener("keydown", this.escapeKeyHandler);
  }
};
</script>
